'use client';

import { FC } from 'react';

import CasesChunkedSlider from '@/components/CasesChunkedSlider';
import { mapCaseToSlideItem } from '@/components/CaseStudiesPage/mapCaseToSlideItem';
import { useCustomCursor } from '@/hooks/useCustomCursor';
import { CaseStudyDto } from '@/types/case-studies';

import css from './style.module.scss';

interface Props {
	cases: CaseStudyDto[];
	htmlId?: string;
}

const RelevantCasesContent: FC<Props> = ({ cases, htmlId }) => {
	const { setCursorVariant, setIsCursorVisible } = useCustomCursor();
	const items = cases.flatMap(mapCaseToSlideItem);

	if (!items.length) return null;

	return (
		<div id={htmlId} onMouseEnter={() => setCursorVariant('lottie-green-visit-case')}>
			<CasesChunkedSlider
				className={css.slider}
				title="Explore more cases"
				items={items}
				withOverlay={false}
				disableBreakpoint={600}
				showTotalCount={false}
				setIsCustomCursorVisible={setIsCursorVisible}
			/>
		</div>
	);
};

export default RelevantCasesContent;
